"use client";
import React from "react";
import HeroAreaOne from "@/components/hero-area/hero-area-one";
import ServiceOne from "@/components/service/service-one";
import AboutOne from "@/components/about/about-one";
import CounterOne from "@/components/counter/counter-one";
import ProgramArea from "@/components/program/program-area";
import TestimonialOne from "@/components/testimonial/testimonial-one";
import BlogOne from "@/components/blog/blog-one";
import InstagramArea from "@/components/instagram/instagram-area";
import CtaOne from "@/components/cta/cta-one";

export default function HomePage() {
  return (
    <main>
      <HeroAreaOne />
      <ServiceOne />
      <AboutOne />
      <CounterOne />
      <ProgramArea />
      <TestimonialOne />
      <BlogOne />
      <InstagramArea />
      <CtaOne />
    </main>
  );
}
